type ButtonProps = Omit<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "onClick"
>;

type Props = {
  variant?: "default" | "primary" | "danger" | "icon";
  text?: string;
  icon?: React.ReactNode;
  className?: string;
  onClickHandler?: () => void;
} & ButtonProps;

export default function CustomButton({
  icon,
  text,
  variant,
  className,
  onClickHandler,
  ...rest
}: Props) {
  if (variant === "primary")
    return (
      <button
        {...rest}
        onClick={onClickHandler}
        className={`${
          icon ? "flex items-center gap-2" : ""
        } rounded border-2 border-primary bg-primary px-6 py-2 text-base font-medium text-white shadow-default hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      >
        <span>{text}</span>
        {icon}
      </button>
    );

  if (variant === "danger") {
    return (
      <button
        {...rest}
        onClick={onClickHandler}
        className={`${
          icon ? "flex items-center gap-2" : ""
        } rounded border-2 border-danger bg-danger px-6 py-2 text-base font-medium text-white shadow-default disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      >
        <span>{text}</span>
        {icon}
      </button>
    );
  }

  if (variant === "icon") {
    return (
      <button
        {...rest}
        onClick={onClickHandler}
        className={`${
          icon ? "flex items-center gap-2" : ""
        } rounded border-2 border-transparent bg-transparent px-2 py-4 text-base font-medium text-white shadow-default hover:border-secondary hover:bg-secondary disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      >
        {icon}
      </button>
    );
  }

  return (
    <button
      {...rest}
      onClick={onClickHandler}
      className={`${
        icon ? "flex items-center gap-2" : ""
      } rounded border-2 border-primary px-6 py-2 text-base font-medium text-primary shadow-default hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
    >
      {text}
      {icon}
    </button>
  );
}
